import apiClient from './apiClient'
import ProfileApiClient from '../settings/apiClient'

export const actionNames = {
  GET_CUSTOM_LABELS: 'getCustomLabels',
  GET_AUTHORS: 'getAuthors',
  ADD_CUSTOM_LABEL: 'addCustomLabel',
  UPDATE_CUSTOM_LABEL: 'updateCustomLabel',
  DELETE_CUSTOM_LABEL: 'deleteCustomLabel',
  SET_CUSTOM_LABEL_PROJECT_FILTER: 'setCustomLabelProjectFilter',
  SET_CUSTOM_LABEL_AUTHOR_FILTER: 'setCustomLabelAuthorFilter'
}

export const module = {
  state: {
    customLabels: [],
    authors: [],
    projectFilter: null,
    authorFilter: null
  },
  getters: {
    filteredCustomLabels (state) {
      return state.customLabels
        .filter(cl => !state.projectFilter || cl.projects.find(p => p.id === state.projectFilter))
        .filter(cl => !state.authorFilter || cl.creatorId === state.authorFilter)
    }
  },
  mutations: {
    setCustomLabels (state, customLabels) {
      state.customLabels = customLabels
    },
    setAuthors (state, authors) {
      state.authors = authors
    },
    addCustomLabel (state, customLabel) {
      state.customLabels = [...state.customLabels, customLabel]
    },
    updateCustomLabel (state, updatedCustomLabel) {
      state.customLabels = state.customLabels.map((cl) => {
        if (cl.id === updatedCustomLabel.id) {
          return updatedCustomLabel
        } else {
          return cl
        }
      })
    },
    deleteCustomLabel (state, customLabelId) {
      state.customLabels = state.customLabels.filter(cl => cl.id !== customLabelId)
    }

  },
  actions: {
    async [actionNames.GET_CUSTOM_LABELS] ({ commit, rootState }) {
      commit('setCustomLabels', await apiClient.getCustomLabels(rootState.auth.clientId))
    },
    async [actionNames.GET_AUTHORS] ({ commit, rootState }) {
      commit('setAuthors', await ProfileApiClient.getMembers(rootState.auth.clientId))
    },
    async [actionNames.ADD_CUSTOM_LABEL] ({ commit, rootState }, customLabel) {
      commit('addCustomLabel', await apiClient.addCustomLabel(rootState.auth.clientId, customLabel))
    },
    async [actionNames.UPDATE_CUSTOM_LABEL] ({ commit, rootState }, customLabel) {
      commit('updateCustomLabel', await apiClient.updateCustomLabel(rootState.auth.clientId, customLabel.id, customLabel.customLabel))
    },
    async [actionNames.DELETE_CUSTOM_LABEL] ({ commit, rootState }, id) {
      await apiClient.deleteCustomLabel(rootState.auth.clientId, id)
      commit('deleteCustomLabel', id)
    },
    async [actionNames.SET_CUSTOM_LABEL_PROJECT_FILTER] ({ state }, projectFilter) {
      state.projectFilter = projectFilter
    },
    async [actionNames.SET_CUSTOM_LABEL_AUTHOR_FILTER] ({ state }, authorFilter) {
      state.authorFilter = authorFilter
    }
  }
}
